import { PasswordResetDeliveryMethod } from 'signature-public-api-sdk';
import { AppThunk } from '€slices/types';
import { actions } from './password-reset-slice';
import api from '€api/client';
import {
    RequestResetEmailProps,
    RequestResetPasswordProps,
} from '€slices/password-reset/password-reset-types';
import { callApi } from '€slices/network';
import { getResetTokenValidationState } from '€slices/password-reset/password-reset-selectors';
import { RequestState } from '~/src/types/RequestState';

export const requestResetEmail =
    ({ username }: RequestResetEmailProps): AppThunk =>
    async dispatch => {
        dispatch(actions.requestEmail());

        const [error, data] = await dispatch(
            callApi(
                api.ClientPortal.Email.requestPasswordReset(
                    username,
                    PasswordResetDeliveryMethod.Email,
                ),
            ),
        );

        if (error) {
            dispatch(actions.receiveEmailError());

            throw error.error;
        }

        dispatch(actions.receiveEmailSuccess(username));

        return data;
    };

export const requestResetPassword =
    ({ currentPassword, newPassword }: RequestResetPasswordProps): AppThunk =>
    async dispatch => {
        dispatch(actions.requestReset());

        const [error, data] = await dispatch(
            callApi(api.BrokerPortal.Users.updatePassword(currentPassword, newPassword)),
        );

        if (error) {
            dispatch(actions.receiveResetError(error.response));

            throw error.error;
        }

        dispatch(actions.receiveResetSuccess());
    };

export const validateResetPasswordToken =
    (token): AppThunk =>
    async (dispatch, getState) => {
        const requestState = getResetTokenValidationState(getState());

        if (requestState === RequestState.Loading) {
            return;
        }

        dispatch(actions.requestValidateToken());

        const [error] = await dispatch(
            callApi(api.ClientPortal.Email.validatePasswordResetToken(token)),
        );

        if (error) {
            dispatch(actions.errorValidateToken());
        } else {
            dispatch(actions.successValidateToken(token));
        }
    };
